import { useOutletContext } from "react-router-dom";
import { NEXTGEN_MAX_CONTENT_WIDTH } from "~/lib/layout";
import { Agent } from "~/services/agents";
import AgentConversationTable from "./AgentConversationTable";

export const AgentConversationsTab = () => {
  const agent = useOutletContext<Agent>();
  return (
    <div
      className="mx-auto flex w-full flex-col gap-4"
      style={{ maxWidth: NEXTGEN_MAX_CONTENT_WIDTH }}
    >
      <h2 className="text-2xl font-semibold">Sessions</h2>
      <AgentConversationTable agentId={agent.id} />
    </div>
  );
};
